import React from 'react'
import styled from '@emotion/styled'
import { useStaticQuery, graphql } from 'gatsby'
import logoImages from 'src/images/top/client_logo.png'
import { BreakPoint } from 'src/components/shared/CssValues'
import { vwSize } from 'src/utils/vwCss'

export const TopClientLogo = () => {

  const data = useStaticQuery(graphql`
    query {
      topImagePrizeIcon1: file(relativePath: { eq: "top/icon_ITreview_2023_6category.png" }) {
        publicURL
      }
      topImagePrizeIcon2: file(relativePath: { eq: "top/icon_ITreview_2023.png" }) {
        publicURL
      }
    }
  `)

  return (
    <Container>
      <CompanyLogo>
        <LogoImg1 src={logoImages} alt="導入企業ロゴ"></LogoImg1>
        <LogoImg2 src={logoImages} alt="導入企業ロゴ"></LogoImg2>
      </CompanyLogo>
      <PrizeImages>
        <PrizeImage1
          src={data.topImagePrizeIcon1.publicURL}
          alt=""
        />
        <PrizeImage2
          src={data.topImagePrizeIcon2.publicURL}
          alt=""
        />
      </PrizeImages>
    </Container>
  )
}

const Container = styled.section`
`

const CompanyLogo = styled.dev`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  overflow: hidden;
  height: 100%;
  background: #ffffff;
  padding: 10px 0;
  z-index: 100;
  position: relative;
`

const LogoImg1 = styled.img`
  height: ${vwSize(50, 'pc')}vw;
  padding-left: ${vwSize(38, 'pc')}vw;
  -webkit-animation: loop 100s -50s linear infinite;
  animation: loop 100s -50s linear infinite;

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    height: ${vwSize(64, 'sp')}vw;
    padding-left: ${vwSize(38, 'sp')}vw;
  }

  @-webkit-keyframes loop {
    0% {
     -webkit-transform: translateX(100%);
     transform: translateX(100%);
    }
    100% {
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
    
  @keyframes loop {
    0% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
    100% {
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
`

const LogoImg2 = styled.img`
  height: ${vwSize(50, 'pc')}vw;
  padding-left: ${vwSize(38, 'pc')}vw;
  -webkit-animation: loop2 100s linear infinite;
  animation: loop2 100s linear infinite;

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    height: ${vwSize(64, 'sp')}vw;
    padding-left: ${vwSize(38, 'sp')}vw;
  }

  @-webkit-keyframes loop2 {
    0% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    100% {
      -webkit-transform: translateX(-200%);
      transform: translateX(-200%);
    }
  }
  
  @keyframes loop2 {
    0% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    100% {
      -webkit-transform: translateX(-200%);
      transform: translateX(-200%);
    }
  }
`

const PrizeImages = styled.div`
  display: none;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    box-sizing: border-box;
    padding: ${vwSize(24, 'sp')}vw 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`
const PrizeImage1 = styled.img`
  width: ${vwSize(210, 'sp')}vw;
  margin-bottom: ${vwSize(16, 'sp')}vw;
`
const PrizeImage2 = styled.img`
  width: ${vwSize(300, 'sp')}vw;
`
